import { Layout, Menu } from 'antd';
import React, { useContext } from 'react';
import { DashboardOutlined, UserOutlined, DatabaseOutlined, PayCircleOutlined, DeliveredProcedureOutlined, TagsOutlined} from "@ant-design/icons";
import { useHistory } from 'react-router-dom';
import { UserContext } from '../Context/UserContext';
import { ThemeContext } from '../Context/ThemeContext';

const {Sider} = Layout
const menuSidebarAdmin = [{
    label: "Dashboard",
    key: '/dashboard-admin',
    icon: <DashboardOutlined />
  },{
    label: "Product",
    key: "/table-product",
    icon: <DatabaseOutlined />
  },{
    label: "Category",
    key: "/table-category",
    icon: <TagsOutlined />
  },{
    label: "Order",
    key: "/table-order",
    icon: <DeliveredProcedureOutlined />
  },{
    label: "Walletyan",
    key: "/walletyan",
    icon: <PayCircleOutlined />
  },{
    label: "Profile",
    key: '/profile',
    icon: <UserOutlined/>
  }
]

const menuSidebar = [{
    label: "Dashboard",
    key: '/dashboard',
    icon: <DashboardOutlined />
  },{
    label: "Order",
    key: "/table-order",
    icon: <DeliveredProcedureOutlined />
  },{
    label: "Walletyan",
    key: "/walletyan",
    icon: <PayCircleOutlined />
  },{
    label: "Profile",
    key: '/profile',
    icon: <UserOutlined />
  }
]

const Sidebar = () => {
  let history = useHistory()
  const [user] = useContext(UserContext)
  const [theme] = useContext(ThemeContext)

  const changeNameClass =  theme === 'dark' ? 'dark-nav' : theme === 'light' ? 'light-nav': ''

  const HandleMenuSidebar = (props) => {
    history.push(props.key)
  }

  return (
    <Sider className={changeNameClass} width={200}>
      {user.username === "admin" ?
      <Menu
        className={changeNameClass}
        mode="inline"
        defaultSelectedKeys={['/dashboard-menu']}
        defaultOpenKeys={['/dashboard-menu']}
        items={menuSidebarAdmin}
        onClick={HandleMenuSidebar}
        key={menuSidebarAdmin.key}
      />
      :
      <Menu
        className={changeNameClass}
        mode="inline"
        defaultSelectedKeys={['/dashboard-menu']}
        defaultOpenKeys={['/dashboard-menu']}
        style={{
        height: '100%',
        background: '#FED766',
        color: '#272727'
        }}
        items={menuSidebar}
        onClick={HandleMenuSidebar}
        key={menuSidebar.key}
      /> 
      }
                           
    </Sider>
  )
}

export default Sidebar